/**
 * Catálogo dos endpoints públicos da API de leads (explorador estilo Swagger).
 */

export const LEAD_API_EXPLORER_ENDPOINTS = [
  {
    id: 'createLead',
    group: 'create',
    method: 'POST',
    path: '/public/leads',
    titleKey: 'integracao.leadApi.ep.createLeadTitle',
    descKey: 'integracao.leadApi.ep.createLeadDesc',
    queryParams: [],
    bodyTemplate: {
      nome: 'Maria Silva',
      email: 'maria@empresa.com',
      telefone: '5541999999999',
      empresa: 'ACME Ltda',
      cargo: 'Diretora',
      cnpj: '12.345.678/0001-90',
      origem: 'API - Teste',
      observacoes: 'Lead criado pelo explorador de API'
    }
  },
  {
    id: 'createLeadWhatsapp',
    group: 'crm',
    method: 'POST',
    path: '/public/crm-api/leads',
    titleKey: 'integracao.leadApi.ep.createLeadWhatsappTitle',
    descKey: 'integracao.leadApi.ep.createLeadWhatsappDesc',
    queryParams: [],
    bodyTemplate: {
      whatsapp: '5541999999999',
      nome: 'Maria Silva'
    }
  },
  {
    id: 'renameLead',
    group: 'crm',
    method: 'PATCH',
    path: '/public/crm-api/leads/nome',
    titleKey: 'integracao.leadApi.ep.renameLeadTitle',
    descKey: 'integracao.leadApi.ep.renameLeadDesc',
    queryParams: [],
    bodyTemplate: {
      whatsapp: '5541999999999',
      nome: 'Maria S.'
    }
  },
  {
    id: 'lookup',
    group: 'crm',
    method: 'GET',
    path: '/public/crm-api/leads/lookup',
    titleKey: 'integracao.leadApi.ep.lookupTitle',
    descKey: 'integracao.leadApi.ep.lookupDesc',
    queryParams: [
      { key: 'whatsapp', labelKey: 'integracao.leadApi.explorer.paramWhatsapp', defaultValue: '5541999999999', type: 'text' }
    ],
    bodyTemplate: null
  },
  {
    id: 'tags',
    group: 'crm',
    method: 'GET',
    path: '/public/crm-api/tags',
    titleKey: 'integracao.leadApi.ep.tagsTitle',
    descKey: 'integracao.leadApi.ep.tagsDesc',
    queryParams: [],
    bodyTemplate: null
  },
  {
    id: 'users',
    group: 'crm',
    method: 'GET',
    path: '/public/crm-api/users',
    titleKey: 'integracao.leadApi.ep.usersTitle',
    descKey: 'integracao.leadApi.ep.usersDesc',
    queryParams: [],
    bodyTemplate: null
  },
  {
    id: 'agendamentos',
    group: 'crm',
    method: 'GET',
    path: '/public/crm-api/agendamentos',
    titleKey: 'integracao.leadApi.ep.agendamentosTitle',
    descKey: 'integracao.leadApi.ep.agendamentosDesc',
    queryParams: [],
    bodyTemplate: null
  },
  {
    id: 'addTag',
    group: 'crm',
    method: 'POST',
    path: '/public/crm-api/leads/tags',
    titleKey: 'integracao.leadApi.ep.addTagTitle',
    descKey: 'integracao.leadApi.ep.addTagDesc',
    queryParams: [],
    bodyTemplate: { whatsapp: '5541999999999', tagId: 1 }
  },
  {
    id: 'removeTag',
    group: 'crm',
    method: 'DELETE',
    path: '/public/crm-api/leads/tags',
    titleKey: 'integracao.leadApi.ep.removeTagTitle',
    descKey: 'integracao.leadApi.ep.removeTagDesc',
    queryParams: [
      { key: 'whatsapp', labelKey: 'integracao.leadApi.explorer.paramWhatsapp', defaultValue: '5541999999999', type: 'text' },
      { key: 'tagId', labelKey: 'integracao.leadApi.explorer.paramTagId', defaultValue: '1', type: 'number' }
    ],
    bodyTemplate: null
  },
  {
    id: 'agendamentoForms',
    group: 'crm',
    method: 'GET',
    path: '/public/crm-api/agendamento-forms',
    titleKey: 'integracao.leadApi.ep.agendamentoFormsTitle',
    descKey: 'integracao.leadApi.ep.agendamentoFormsDesc',
    queryParams: [],
    bodyTemplate: null
  },
  {
    id: 'assignUser',
    group: 'crm',
    method: 'POST',
    path: '/public/crm-api/leads/assign-user',
    titleKey: 'integracao.leadApi.ep.assignUserTitle',
    descKey: 'integracao.leadApi.ep.assignUserDesc',
    queryParams: [],
    bodyTemplate: { whatsapp: '5541999999999', usuarioId: 1 }
  }
]

export function buildEndpointUrl (baseUrl, path, queryValues = {}) {
  const base = (baseUrl || '').replace(/\/$/, '')
  const relativePath = path?.startsWith('/') ? path : `/${path || ''}`
  let url = `${base}${relativePath}`
  const qs = Object.entries(queryValues)
    .filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v).trim())}`)
    .join('&')
  if (qs) {
    url += url.includes('?') ? `&${qs}` : `?${qs}`
  }
  return url
}

export function getFullPath (ep, queryValues = {}) {
  if (!ep?.path) return ''
  const qs = Object.entries(queryValues)
    .filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v).trim())}`)
    .join('&')
  return qs ? `${ep.path}?${qs}` : ep.path
}

export function defaultQueryValues (ep) {
  const out = {}
  if (!ep?.queryParams?.length) return out
  for (const p of ep.queryParams) {
    out[p.key] = p.defaultValue ?? ''
  }
  return out
}

export function defaultBodyJson (ep) {
  if (!ep?.bodyTemplate) return ''
  return JSON.stringify(ep.bodyTemplate, null, 2)
}
